import { type NestedCSSProperties, type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const primaryButton = (loading?: boolean, fullWidth?: boolean, disabled?: boolean): NestedCSSProperties => ({
  transitionDuration: '500ms',
  transitionProperty: 'background-color',
  backgroundColor: !disabled ? StyleConstants.MEDIUM_BLUE_COLOR : StyleConstants.GREY_COLOR,
  fontSize: StyleConstants.PRIMARY_BUTTON_FONT_SIZE,
  fontWeight: StyleConstants.PRIMARY_BUTTON_FONT_WEIGHT,
  color: StyleConstants.WHITE_COLOR,
  width: fullWidth ? undefined : 180,
  height: 32,
  borderRadius: 8,
  boxSizing: 'border-box',
  cursor: disabled ? 'default' : 'pointer',
  position: 'relative',
  userSelect: 'none',
});

export const icon: CSSProperties = {
  position: 'absolute',
  fontSize: 20,
  left: 16,
  top: '50%',
  transform: 'translateY(-50%)',
};

export const tooltip: CSSProperties = {
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  width: 250,
};

export const tooltipIcon: CSSProperties = {
  cursor: 'pointer',
  color: StyleConstants.GREY_COLOR,
  height: 18,
  width: 18,
};
